import { memo } from '@morphic-ts/common/es6/utils';
import { getShow as EgetShow } from 'fp-ts/Either';
import { pipe } from 'fp-ts/es6/function';
import { getShow as OgetShow } from 'fp-ts/Option';
import { getShow as AgetShow } from 'fp-ts/ReadonlyArray';
import { getShow as NEAgetShow } from 'fp-ts/ReadonlyNonEmptyArray';
import { showBoolean, showNumber, showString } from 'fp-ts/Show';
import { showApplyConfig } from '../config';
import { ShowType, ShowURI } from '../hkt';
const showStringOrNumber = {
    show: a => `${a}`
};
const showUndefinedOf = (s) => ({
    show: a => (a === undefined ? '<undefined>' : s.show(a))
});
/**
 *  @since 0.0.1
 */
export const showPrimitiveInterpreter = memo(() => ({
    _F: ShowURI,
    date: config => env => new ShowType(showApplyConfig(config)({ show: (date) => date.toISOString() }, env, {})),
    boolean: config => env => new ShowType(showApplyConfig(config)(showBoolean, env, {})),
    string: config => env => new ShowType(showApplyConfig(config)(showString, env, {})),
    number: config => env => new ShowType(showApplyConfig(config)(showNumber, env, {})),
    bigint: config => env => new ShowType(showApplyConfig(config)({ show: a => JSON.stringify(a) }, env, {})),
    stringLiteral: (_, config) => env => new ShowType(showApplyConfig(config)(showString, env, {})),
    numberLiteral: (_, config) => env => new ShowType(showApplyConfig(config)(showNumber, env, {})),
    oneOfLiterals: (_, config) => env => new ShowType(showApplyConfig(config)(showStringOrNumber, env, {})),
    tag: (_, config) => env => new ShowType(showApplyConfig(config)(showString, env, {})),
    keysOf: (_keys, config) => env => new ShowType(showApplyConfig(config)(showString, env, {})),
    nullable: (getShow, config) => env => pipe(getShow(env).show, show => new ShowType(showApplyConfig(config)(OgetShow(show), env, { show }))),
    optional: (getShow, config) => env => pipe(getShow(env).show, show => new ShowType(showApplyConfig(config)(showUndefinedOf(show), env, { show }))),
    mutable: (getShow, config) => env => pipe(getShow(env).show, show => new ShowType(showApplyConfig(config)(show, env, { show }))),
    array: (getShow, config) => env => pipe(getShow(env).show, show => new ShowType(showApplyConfig(config)(AgetShow(show), env, { show }))),
    nonEmptyArray: (getShow, config) => env => pipe(getShow(env).show, show => new ShowType(showApplyConfig(config)(NEAgetShow(show), env, { show }))),
    uuid: config => env => new ShowType(showApplyConfig(config)(showString, env, {})),
    either: (e, a, config) => env => ((left, right) => new ShowType(showApplyConfig(config)(EgetShow(left, right), env, { left, right })))(e(env).show, a(env).show),
    option: (getShow, config) => env => pipe(getShow(env).show, show => new ShowType(showApplyConfig(config)(OgetShow(show), env, { show }))),
    unknownE: (getShow, config) => env => pipe(getShow(env).show, show => new ShowType(showApplyConfig(config)(show, env, { show })))
}));
